/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Users.css";
import { fetchUsers, resetStateUsers } from "../../app/slices/userSlice";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import AppDataTable from "../../components/AppDataTable/appDataTable";
import { Button } from "@mui/material";
import UserDialog from "./UserDialog";
import { hasAccess } from "../../app/utils";

const UserManagement = () => {
  const { data, status, error } = useSelector(({ users }) => users.get);

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [method, setMethod] = useState("ADD");
  const [selectedUser, setSelectedUser] = useState(null);
  const [listUsers, setListUsers] = useState(null);
  const dispatch = useDispatch();

  const columns = [
    {
      name: "full_name",
      label: "Full Name",
    },
    {
      name: "email",
      label: "Email",
    },
    {
      name: "phone",
      label: "Phone",
    },
    {
      name: "role_name",
      label: "Role",
    },
    {
      name: "institution_name",
      label: "Institution",
    },
    {
      name: "statusDisplay",
      label: "Status",
      options: {
        align: "center",
      },
    },
  ];

  //use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateUsers());
    };
  }, []);

  useEffect(() => {
    if (data) {
      let _list = [];
      data?.forEach((user) => {
        _list.push({
          ...user,
          statusDisplay: translateStatus(user?.status),
        });
      });

      setListUsers(_list);
    }
  }, [data]);

  //methods

  const translateStatus = (status) => {
    if (status === "A") {
      return "Active";
    } else if (status === "I") {
      return "Inactive";
    } else if (status === "D") {
      return "Disabled";
    } else {
      return status;
    }
  };

  const loadResources = () => {
    dispatch(resetStateUsers());
    dispatch(fetchUsers());
  };
  //builders
  return (
    <>
      <div className="app-padding mt-20 mb-50">
        {hasAccess("USER_ADMINISTRATION") && (
          <Button
            variant="outlined"
            onClick={() => {
              setMethod("ADD");
              setSelectedUser(null);
              setIsOpenDialog(true);
            }}
          >
            + Register User
          </Button>
        )}

        {status === "idle" && listUsers && (
          <AppDataTable
            id="user-list"
            actions={[
              {
                action: "Update",
                renderCheck: () => {
                  return hasAccess("USER_ADMINISTRATION");
                },
                onClick: (item) => {
                  setMethod("UPDATE");
                  setSelectedUser({
                    fullName: item?.full_name,
                    email: item?.email,
                    role: item?.role_id,
                    institution: item?.institution_id,
                    ...item,
                  });
                  setIsOpenDialog(true);
                },
              },
            ]}
            columns={columns}
            data={listUsers}
            emptyMessage="No users found."
            rowsPerPageOptions={[10, 20, 50, 100]}
            downloadFileName="TzFincert users"
          />
        )}
        {status === "loading" && <LoadingContainer message={"loading users"} />}
        {status !== "loading" && error && (
          <ErrorContainer message={error?.message} onReload={loadResources} />
        )}
      </div>

      {/* User dialog */}
      {isOpenDialog && (
        <UserDialog
          selectedUser={selectedUser}
          open={isOpenDialog}
          method={method}
          onClose={(refresh) => {
            setIsOpenDialog(false);
            if (refresh) {
              loadResources();
            }
          }}
          title={method === "ADD" ? "Register User" : "Update User"}
        />
      )}
      {/* User dialog */}
    </>
  );
};

export default UserManagement;
